import View from '../view';
import Modal from '@mui/material/Modal';
import './index_web.css';
import useTheme from '../../utilities/hooks/theme';
import constants from '../../constants';
import Text from '../text';
import { BsCheckSquareFill, BsSquare } from 'react-icons/bs';
import React from 'react';
import FormControl from '@mui/material/FormControl';
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import Constants from '../../constants';
import OtpInput from 'react-otp-input';

interface Props {
  visible: boolean;
  onPressClose: any;
  handleCloseModal: any;
  surfaceStyle: any;
  isLogin: boolean;
  isMobileLogin: boolean;
  isSignUp: boolean;
  handleUserNameChange: any;
  showPassword: boolean;
  updatePassword: any;
  handleClickShowPassword: any;
  handleMouseDownPassword: any;
  handleMobileNumberChange: any;
  otpEnabled: boolean;
  otp: any;
  onChangeOTP: any;
  passwordError: boolean;
  userError: boolean;
  otpError: boolean;
  phoneNumberError: boolean;
  isChecked: boolean;
  handleCheckState: any;
  onClickMobileLogin: any;
  loginSignUpBtnStyle: any;
  handleLoginSignUp: any;
  handleMobileLogin: any;
  handleRequestOtp: any;
  loginWithOthers: any;
  setSignUpActive: any;
  setLoginActive: any;
}

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3)
  },
  '& .MuiInputBase-input': {
    marginTop: '10px',
    borderRadius: 4,
    position: 'relative',
    backgroundColor: '#222c38',
    border: '1px solid #3b424b',
    fontSize: 14,
    width: '100%',
    padding: '10px 12px',
    color: '#bbe6ff',
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: ['Poppins'].join(','),
    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: '#3b424b'
    }
  }
}));
interface ErrorProps {
  errorText: any;
}
const Error = ({ errorText }: ErrorProps) => {
  return <div className="errorText__container">{errorText}</div>;
};

const LoginSignUpModalWeb = ({
  visible,
  onPressClose,
  handleCloseModal,
  surfaceStyle,
  isLogin,
  isMobileLogin,
  isSignUp,
  handleUserNameChange,
  showPassword,
  updatePassword,
  handleClickShowPassword,
  handleMouseDownPassword,
  handleMobileNumberChange,
  otpEnabled,
  otp,
  onChangeOTP,
  passwordError,
  userError,
  otpError,
  phoneNumberError,
  isChecked,
  handleCheckState,
  onClickMobileLogin,
  loginSignUpBtnStyle,
  handleLoginSignUp,
  handleMobileLogin,
  handleRequestOtp,
  loginWithOthers,
  setSignUpActive,
  setLoginActive
}: Props) => {
  const { DashboardTheme: theme } = useTheme();

  return (
    <Modal open={visible} onClose={onPressClose}>
      <View className="loginSignUpModal__wrapper__web" style={surfaceStyle}>
        <span className={'loginSignUpModal__close__btn__web'}>
          <Constants.Svgs.Close
            onClick={handleCloseModal}
            className={'loginSignUpModal__close__btn__web'}
          />
        </span>

        <div className="loginSignUpModal__img__container__web">
          <img src={constants.Images.loginSignUpBanner} />
        </div>
        <View className="loginSignUpModal__form__container__web">
          <View className="loginSignUpModal__form__title__container__web">
            <Text className="loginSignUpModal__form__title__web">
              {isLogin || isMobileLogin ? 'Log In' : isSignUp ? `Sign Up` : ''}
            </Text>
          </View>
          {isLogin || isSignUp ? (
            <React.Fragment>
              {' '}
              <FormControl variant="standard">
                <BootstrapInput
                  defaultValue=""
                  id="bootstrap-input"
                  placeholder="username"
                  type={'text'}
                  onChange={(e) => handleUserNameChange(e.target.value)}
                />
              </FormControl>
              <FormControl variant="standard">
                <BootstrapInput
                  defaultValue=""
                  id="bootstrap-input"
                  placeholder="password"
                  type={showPassword ? 'text' : 'password'}
                  onChange={(e) => updatePassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        color="info"
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <FormControl variant="standard">
                <BootstrapInput
                  defaultValue=""
                  id="bootstrap-input"
                  placeholder="Phone number"
                  type={'text'}
                  onChange={(e) => handleMobileNumberChange(e.target.value)}
                />
              </FormControl>
              {otpEnabled && (
                <OtpInput
                  value={otp}
                  onChange={onChangeOTP}
                  numInputs={6}
                  className={'otp-verification-input'}
                  isInputNum={true}
                  inputStyle={{
                    backgroundColor: '#222c38',
                    border: '1px solid #3b424b',
                    width: '50px',
                    height: '50px',
                    borderRadius: 5,
                    borderWidth: 0,
                    borderColor: '#484e6d',
                    color: '#bbe6ff',
                    fontSize: '1.2rem',
                    outline: 0
                  }}
                  separator={
                    <span
                      style={{
                        padding: 5
                      }}></span>
                  }
                />
              )}
            </React.Fragment>
          )}
          {(passwordError || userError) && <Error errorText={'Username or password is invalid'} />}
          {otpError && <Error errorText={'Please enter a valid otp'} />}
          {phoneNumberError && <Error errorText={'Please enter a valid phone number'} />}
          {isLogin && (
            <View className="loginSignUpModal__forgotPassword__container">
              <View className="loginSignUpModal__rememberMe__Check__container">
                {!isChecked && (
                  <BsSquare
                    size={'20px'}
                    fill={theme.loginSignUpSelectAllBtnDefault}
                    onClick={handleCheckState}
                  />
                )}
                {isChecked && (
                  <BsCheckSquareFill
                    size={'20px'}
                    fill={theme.loginSignUpSelectAllBtnActive}
                    onClick={handleCheckState}
                  />
                )}
                <p className="rememberMe__text">Remember me</p>
              </View>
              <View className="forgotPassword__txt">Forgot Password?</View>
            </View>
          )}
          {isSignUp && (
            <View className="loginSignUpModal__terms__container">
              {!isChecked && (
                <BsSquare
                  size={'20px'}
                  fill={theme.loginSignUpSelectAllBtnDefault}
                  onClick={handleCheckState}
                />
              )}
              {isChecked && (
                <BsCheckSquareFill
                  size={'20px'}
                  fill={theme.loginSignUpSelectAllBtnActive}
                  onClick={handleCheckState}
                />
              )}
              <View style={{ marginLeft: '8px' }}>
                <span>By continuing, you agree to our </span>
                <span className="termsConditions__text">Terms & conditions</span>
              </View>
            </View>
          )}

          {isLogin && (
            <View
              className="loginSignUpModal__MobileLogin__option__txt"
              onPress={onClickMobileLogin}>
              Login with a mobile number instead
            </View>
          )}
          {(isLogin || isSignUp) && (
            <button
              className="loginSignUpModal__btn__web"
              style={loginSignUpBtnStyle}
              onClick={handleLoginSignUp}>
              {isLogin ? 'Log In' : 'Sign Up'}
            </button>
          )}
          {isMobileLogin && (
            <button
              className="loginSignUpModal__btn__web"
              style={loginSignUpBtnStyle}
              onClick={otpEnabled ? handleMobileLogin : handleRequestOtp}>
              {otpEnabled ? 'Verify & Login' : 'Request Otp'}
            </button>
          )}
          <View className="loginSignUpModal__option__txt">or continue with</View>
          <div className="loginSignUpModal__signUp__options__web">
            <button className="loginSignUpModal__signUp__options__btn" onClick={loginWithOthers}>
              {' '}
              <GoogleIcon fontSize="medium" /> <p>Google</p>
            </button>
            <button className="loginSignUpModal__signUp__options__btn" onClick={loginWithOthers}>
              <FacebookIcon fontSize="medium" /> <p>Facebook</p>
            </button>
          </div>
          <View className="loginSignUpModal__login__option">
            <p className="already__member__txt">
              {isLogin || isMobileLogin
                ? 'New to iGamio?'
                : isSignUp
                ? `Already a member login?`
                : ''}
            </p>
            {(isLogin || isMobileLogin) && (
              <p className="login__txt" onClick={setSignUpActive}>
                {'SignUp'}
              </p>
            )}
            {isSignUp && <p className="login__txt" onClick={setLoginActive}>{`Log In`}</p>}
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default LoginSignUpModalWeb;
